<template>
    <div>
        <div id="chatting_buy_box">
            <div></div>
            <span>您还不是会员哦！查看和参与实时互动请先购买会员！</span>
            <button class="showToastBuyVIP" @click.stop.prevent="openNative('vip_product')">立即开通</button>
        </div>
    </div>
  </template>
  <script>
    import { isLoginInfo } from "@/utils/index";
  export default {
    name: "TabsChattingRoom",
    data() {
      return {
        l_id: parseInt(this.$route.query.l_id) || 0,
      }
    },
    created() {},
    methods: {
        // 跳转APP页面
        openNative(type, query = {}) {
            let params = {
                kind: type, // 类型
            };

            // 同步传参
            params = {
                ...params,
                ...query
            }

            switch(type) {
                case "vip_product": // 会员产品页面
					if(!isLoginInfo()) {
						return
					}
                    params.url = `/up/app/vip_product/wap/?l_id=${this.l_id}`;
                    break;
            }

            this.$srH5CallNativeMethodApp('call_Native', params)
        },
    }
  };
  </script>
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
    #chatting_buy_box {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 0;

        & > div {
            /*width: 255px;
            height: 190px;*/
            width: 204px;
            height: 152px;
            background-image: url("https://cdncos.aigupiao.com/assets/wap/img/chattingRoom/noData.svg");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;
        }

        & > span {
            width: 230px;
            font-size: 15px;
            line-height: 23.25px;
            color: #333;
            margin-bottom: 10px;
            text-align: center;
        }

        & > button {
            width: 150px;
            height: 40px;
            border-radius: 20px;
            background-color: #FE484A;
            border: none;
            color: #fff;
            font-size: 15px;
            cursor: pointer;
        }
    }
  </style>